'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseAxisController=require('../../../../dist-es6/client/directives/plotting/baseAxisController');
const BaseAxisDirective=require('../../../../dist-es6/client/directives/plotting/baseAxisDirective');
const Range=require('pulsar-utils/dist-es6/range');let

CategoryAxisController=class CategoryAxisController extends BaseAxisController{
constructor($scope){
super($scope);
}

_updateScale(){
if(_.exists(this.domain)&&_.exists(this._range)){
this._scale=d3.scale.ordinal().domain(this.domain).rangeRoundPoints([this._range.start,this._range.end],1);
}else
{
this._scale=null;
}
}};let


CategoryAxisDirective=class CategoryAxisDirective extends BaseAxisDirective{
get controller(){return CategoryAxisController}};


module.exports=CategoryAxisDirective;
//# sourceMappingURL=categoryAxisDirective.js.map
